import type { ChangeRequestResponseModel } from "@istari/istari-client";

import type { BranchId } from "~/branching/model/branch";
import type { ChangeRequest, ChangeRequestId } from "~/change-request/model/change-request";

export function toChangeRequest(dto: ChangeRequestResponseModel): ChangeRequest {
  const base = {
    id: dto.changeRequestId as ChangeRequestId,
    title: dto.title ?? undefined,
    description: dto.description ?? undefined,
    sourceBranchId: dto.sourceTagId as BranchId,
    targetBranchId: dto.targetTagId as BranchId,
    createdById: dto.createdById,
    created: dto.created,
  };

  switch (dto.status) {
    case "OPEN":
      return {
        ...base,
        status: "open",
        sourceSnapshotId: dto.currentSourceSnapshotId,
        targetSnapshotId: dto.currentTargetSnapshotId,
      };
    case "MERGED":
      return {
        ...base,
        status: "merged",
        sourceSnapshotId: dto.sourceSnapshotIdAtMerge,
        targetSnapshotId: dto.targetSnapshotIdAfterMerge,
      };
    case "CLOSED":
      return { ...base, status: "closed", sourceSnapshotId: null, targetSnapshotId: null };
  }
}
